import { render, staticRenderFns } from "./CmgRecaptcha.vue?vue&type=template&id=4961cc04&scoped=true&lang=pug&"
import script from "./cmg-recaptcha.ts?vue&type=script&lang=ts&"
export * from "./cmg-recaptcha.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4961cc04",
  null
  
)

export default component.exports